import { render, staticRenderFns } from "./UserOpts.vue?vue&type=template&id=1e12f47e&scoped=true&"
import script from "./UserOpts.vue?vue&type=script&lang=js&"
export * from "./UserOpts.vue?vue&type=script&lang=js&"
import style0 from "./UserOpts.vue?vue&type=style&index=0&id=1e12f47e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e12f47e",
  null
  
)

export default component.exports